var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Fitch = /** @class */ (function () {
    function Fitch(options) {
        this.baseURL = '';
        this.transformRequest = [];
        this.transformResponse = [];
        if (options && Object.keys(options).length > 0) {
            this.baseURL = options.baseURL || '';
            this.transformRequest = options.transformRequest || [];
            this.transformResponse = options.transformResponse || [];
            this.headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, options.headers);
        }
    }
    Fitch.prototype.http = function (path, args) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                path = this.baseURL.concat(path);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var response;
                        args.headers = __assign({}, _this.headers);
                        _this.transformRequest.forEach(function (transformer) {
                            args = transformer(args);
                        });
                        var requestArgs = {
                            method: args.method,
                            body: JSON.stringify(args.body) || null,
                            headers: args.headers
                        };
                        requestArgs.credentials = 'include';
                        var request = new Request(path, requestArgs);
                        fetch(request)
                            .then(function (res) {
                            response = res;
                            return res.text();
                        })
                            .then(function (text) {
                            if (response.ok) {
                                var body = void 0;
                                try {
                                    body = text ? JSON.parse(text) : {};
                                }
                                catch (e) {
                                    body = {};
                                }
                                response.parsedBody = body;
                                _this.transformResponse.forEach(function (transformer) {
                                    response = transformer(response);
                                });
                                resolve(response.parsedBody);
                            }
                            else {
                                reject(response);
                            }
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    })];
            });
        });
    };
    Fitch.prototype.get = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http(path, { method: 'GET' })];
            });
        });
    };
    Fitch.prototype.delete = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http(path, { method: 'DELETE' })];
            });
        });
    };
    Fitch.prototype.post = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http(path, { method: 'POST', body: body })];
            });
        });
    };
    Fitch.prototype.put = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http(path, { method: 'PUT', body: body })];
            });
        });
    };
    Fitch.prototype.patch = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http(path, { method: 'PATCH', body: body })];
            });
        });
    };
    return Fitch;
}());
export { Fitch };
//# sourceMappingURL=fitch.js.map